export enum LanguageId {
  SPANISH = 'es',
  ENGLISH = 'en'
}
export interface Language {
  id: LanguageId;
  label: string;
  img: string;
}

export const SUPPORTED_LANGUAGES: Language[] = [
  {
    id: LanguageId.SPANISH,
    label: 'SETTINGS.GENERAL.LANGUAGES.SPANISH',
    img: 'assets/images/languages/es.svg'
  },
  {
    id: LanguageId.ENGLISH,
    label: 'SETTINGS.GENERAL.LANGUAGES.ENGLISH',
    img: 'assets/images/languages/en.svg'
  }
];
